import { Navigate, Route, Routes } from "react-router-dom";
import HomePage from "@/app/page";
import AccessPage from "@/app/access/page";
import PrivacyPage from "@/app/privacy/page";
import TermsPage from "@/app/terms/page";
import StudioPage from "@/app/studio/page";
import ProjectsPage from "@/app/studio/projects/page";
import AvatarsPage from "@/app/studio/avatars/page";
import AnalyticsPage from "@/app/studio/analytics/page";
import BillingPage from "@/app/studio/billing/page";
import BillingSuccessPage from "@/app/studio/billing/success/page";
import BillingCancelledPage from "@/app/studio/billing/cancelled/page";
import AdminAuditPage from "@/app/admin/audit/page";
import AdminAvatarsPage from "@/app/admin/avatars/page";
import AdminJobsPage from "@/app/admin/jobs/page";
import AdminProductsPage from "@/app/admin/products/page";
import AdminTemplatesPage from "@/app/admin/templates/page";
import TokenPricingPage from "@/app/admin/token-pricing/page";
import AdminUsersPage from "@/app/admin/users/page";
import ViralRemixPage from "@/app/admin/viral-remix/page";
import AdminVoicesPage from "@/app/admin/voices/page";
import AdminWorkflowPage from "@/app/admin/workflow/page";
import { SignInPage, SignUpPage } from "./auth-pages";
import { AdminLayout, StudioLayout } from "./layouts";
import { ProjectPage } from "./project-page";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/access" element={<AccessPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/studio" element={<StudioLayout />}>
        <Route index element={<StudioPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectPage />} />
        <Route path="avatars" element={<AvatarsPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="billing/success" element={<BillingSuccessPage />} />
        <Route path="billing/cancelled" element={<BillingCancelledPage />} />
      </Route>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="workflow" replace />} />
        <Route path="workflow" element={<AdminWorkflowPage />} />
        <Route path="viral-remix" element={<ViralRemixPage />} />
        <Route path="jobs" element={<AdminJobsPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="products" element={<AdminProductsPage />} />
        <Route path="avatars" element={<AdminAvatarsPage />} />
        <Route path="voices" element={<AdminVoicesPage />} />
        <Route path="templates" element={<AdminTemplatesPage />} />
        <Route path="token-pricing" element={<TokenPricingPage />} />
        <Route path="audit" element={<AdminAuditPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
